<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('spareParts.catalogue.title') }}
      </h2>

      <p>{{ $t('spareParts.catalogue.description') }}</p>

      <div class="irinox-form after-sales" >

          <div class="p-fluid p-formgrid p-grid">
              <div :class="['p-field p-col-12']" >
                  <label>{{ $t('spareParts.catalogue.upload_excel') }}</label>

                  <FileUpload
                    ref="uploader"
                    mode="advanced"
                    :multiple="false"
                    :customUpload="true"
                    :showUploadButton="true"
                    :showCancelButton="true"
                    :fileLimit="1"
                    :maxFileSize="10 * 1000 * 1000"
                    :chooseLabel="$t('spareParts.catalogue.upload_excel_choose')"
                    :uploadLabel="$t('spareParts.catalogue.save_document')"
                    :cancelLabel="$t('spareParts.catalogue.reset_form')"
                    @uploader="uploader"
                  >

                    <template #empty>
                      <p>{{ $t('spareParts.catalogue.upload_excel_drag_and_drop') }}</p>
                    </template>
                  </FileUpload> 

              </div>
          </div>

          <div class="p-d-flex p-jc-end p-ai-center">
            <div class="search-bar">
              <i class="pi pi-search" />
              <InputText v-model="filters['global'].value" :placeholder="$t('spareParts.catalogue.search_ph')" :aria-label="$t('spareParts.catalogue.search_ph')"/>
              <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
            </div>
          </div>

          <DataTable v-if="catalogue?.length > 0" :value="catalogue" stripedRows
              responsiveLayout="stack"
              breakpoint="960px"
              :autoLayout="true" class="after-sales-table-full p-mt-4"
              sortField="code" :sortOrder="1"
              :paginator="true" paginatorPosition="bottom" 
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" 
              :rows="10"
              :currentPageReportTemplate="'{totalRecords} ' + $t('spareParts.catalogue.counter')"
              v-model:filters="filters" :globalFilterFields="['code', 'descIt', 'descEn', 'descEs', 'descFr', 'descDe', 'descRu']"
              >
              
              <Column field="code" :header="$t('spareParts.catalogue.col_code')" sortable ></Column>

              <Column :header="$t('spareParts.catalogue.col_description')">
                <template #body="slotProps">
                  <div class="spare-parts-catalogue-desc">
                    <!-- <div><span>IT:</span> {{ slotProps.data.descIt }}</div>
                    <div><span>EN:</span> {{ slotProps.data.descEn }}</div>
                    <div><span>ES:</span> {{ slotProps.data.descEs }}</div>
                    <div><span>FR:</span> {{ slotProps.data.descFr }}</div>
                    <div><span>DE:</span> {{ slotProps.data.descDe }}</div>
                    <div><span>RU:</span> {{ slotProps.data.descRu }}</div> -->
                    
                    <div><img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-it'" :alt="'IT'"/> {{ slotProps.data.descIt }}</div>
                    <div><img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-gb'" :alt="'EN'"/>  {{ slotProps.data.descEn }}</div>
                    <div><img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-es'" :alt="'ES'"/>  {{ slotProps.data.descEs }}</div>
                    <div><img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-fr'" :alt="'FR'"/>  {{ slotProps.data.descFr }}</div>
                    <div><img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-de'" :alt="'DE'"/>  {{ slotProps.data.descDe }}</div>
                    <div><img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-ru'" :alt="'RU'"/>  {{ slotProps.data.descRu }}</div>
                  </div>
                </template>
              </Column>

              <Column field="priceEur" :header="$t('spareParts.catalogue.col_price')" sortable >
                <template #body="slotProps">
                  <div class="p-d-flex p-flex-column p-ai-end" style="gap: 10px">
                    <div v-if="slotProps.data.priceEur != null" class="p-d-flex p-jc-between" style="width: 100%"><span>€</span> <span>{{ $n(slotProps.data.priceEur, 'money') }}</span></div>
                    <div v-if="slotProps.data.priceUsd != null" class="p-d-flex p-jc-between" style="width: 100%"><span>$</span> <span>{{ $n(slotProps.data.priceUsd, 'money') }}</span></div>
                  </div>
                </template>
              </Column>

              <!-- <Column field="priceEur" :header="$t('spareParts.catalogue.col_priceEur')" sortable >
                <template #body="slotProps">
                  <span v-if="slotProps.data.priceEur">€ {{ $n(slotProps.data.priceEur, 'money') }}</span>
                </template>
              </Column>

              <Column field="priceUsd" :header="$t('spareParts.catalogue.col_priceUsd')" sortable >
                <template #body="slotProps">
                  <span v-if="slotProps.data.div">$ {{ $n(slotProps.data.priceUsd, 'money') }}</span>
                </template>
              </Column> -->

              <Column field="recommended" :header="$t('spareParts.catalogue.col_recommended')" sortable >
                <template #body="slotProps">
                  <i v-if="slotProps.data.recommended" class="pi pi-star-fill p-px-1 green" />
                </template>
              </Column>

              <Column field="replacedBy" :header="$t('spareParts.catalogue.col_replacedBy')" sortable ></Column>

              <Column field="insertDate" :header="$t('spareParts.catalogue.col_insertDate')" sortable >
                <template #body="slotProps">
                  <!-- <span>{{ $d(slotProps.data.insertDate, is24hour ? 'long' : 'long12') }}</span> -->
                  <span>{{ $d(slotProps.data.insertDate, 'shortNumeric') }}</span>
                </template>
              </Column>

              <Column field="lastUpdateDate" :header="$t('spareParts.catalogue.col_lastUpdateDate')" sortable >
                <template #body="slotProps">
                  <!-- <span>{{ $d(slotProps.data.lastUpdateDate, is24hour ? 'long' : 'long12') }}</span> -->
                  <span>{{ $d(slotProps.data.lastUpdateDate, 'shortNumeric') }}</span>
                </template>
              </Column>

              <Column></Column>

          </DataTable>

          <div v-else class="empty-list">
            {{ $t('spareParts.catalogue.empty_list') }}
          </div>

      </div>

    </div>
  </div>

  
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.up_success" 
    mode="success" 
    :message="$t('afterSales.upload_doc_success')"
    :life="3000" 
    @update:visible="dialog.up_success = $event" />


</template>

<script>
import { mapGetters } from 'vuex';
import AfterSalesService from '../../../service/AfterSalesService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import {FilterMatchMode} from 'primevue/api';

export default {
  components: { 
    IrinoxDialogDark
  },
  data() {
    return {
      catalogue: [],
      dialog: {
        error: false,
        up_success: false,
      },
      filters: {
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      is24hour: 'userdata/is24hour',
    }),
  },
  watch: {
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() { 
    this.refreshCatalogue();
  },
  methods: {
    refreshCatalogue() {
      this.afterSalesService.getSpCatalogue(this.personaltoken)
        .then((data) => {
          if(data.code==="200") {
            this.catalogue = data.body;
          } else {
            console.error("ERROR "+JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("EXCEPTION "+error);
          this.dialog.error = true;
        });
    },
    uploader(event) {
      this.afterSalesService.uploadSpCatalogue(this.personaltoken, event.files[0])
        .then((data) => {
          if(data.code==="200") {
            this.dialog.up_success = true;
            this.$refs.uploader.clear();
            this.refreshCatalogue();
          } else {
            console.error("ERROR "+JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("EXCEPTION "+error);
          this.dialog.error = true;
        });
    },
  }
}
</script>